module.exports = __webpack_public_path__ + "img/img_5.c7409027.png";